/**
 *  UI-REFACTORED
 *    FROM --> ./legacy-web/src/main/webapp/assets/js/aa/seats/view-seats/view-available-seats.js
 *    TO   --> ./legacy-web/src/main/assets/js/seatmap/view-seats/view-available-seats.js
 **/

//Initialize sandbox
AAcom('utilities', 'ajax', function (AAUI) {
    $j(document).ready(function() {
        AAUI.onClick('#closeButton',function(){
            window.close();
            return false;
        });
    });
});
